<template>
  <form @submit.prevent="save">
    <!-- <close-button @click="$emit('close')" class="close-button"></close-button> -->
    <transition name="overlay-fade"></transition>
    <div class="dialog-header">
      <h1 v-if="isNew">Nieuwe categorie</h1>
      <h1 v-else>Categorie wijzigen</h1>
    </div>
    <div class="dialog-content">
      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label for="name">Naam</label>
          <div>
            <input
              id="name"
              type="text"
              v-model="displayCategory.name"
              ref="name"
              :class="{ invalid: !displayCategory.name }"
              @input="onNameInput"
            />
          </div>
        </div>
      </div>
      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label for="color">Kleur (HEX code)</label>
          <div>
            <input
              id="color"
              type="text"
              v-model="displayCategory.colour"
              ref="color"
              @input="$v.displayCategory.$touch()"
            />
          </div>
        </div>
      </div>
      <div class="select-wrapper">
        <select-box
          @action="setHidden()"
          :selected="!displayCategory.active"
        ></select-box>

        <span class="pointer" @click="setHidden()"
          >Deze categorie verbergen</span
        >
      </div>
      <div class="select-wrapper">
        <select-box
          :selected="displayCategory.listOnTop"
          @action="setListOnTop"
        ></select-box
        ><span @click="setListOnTop" class="pointer"
          >Deze categorie bovenaan tonen</span
        >
      </div>
      <div class="select-wrapper">
        <select-box
          :selected="displayCategory.newBadge"
          @action="setNewBadge"
        ></select-box
        ><span @click="setNewBadge" class="pointer"
          >"Nieuw" badge tonen bij categorie</span
        >
      </div>
      <div class="error">
        <p v-show="catExists()">
          Let op, er bestaat al een categorie met deze naam.
        </p>
      </div>

      <div class="button-holder">
        <button
          class="pill-button secondary cancel"
          type="button"
          @click="$emit('close')"
        >
          annuleren
        </button>
        <button
          id="confirm-button"
          class="pill-button"
          type="submit"
          :disabled="
            $v.displayCategory.$invalid ||
            !$v.displayCategory.$dirty ||
            saving ||
            catExists()
          "
        >
          <span v-if="isNew">Creëren</span>
          <span v-else>Wijzigen</span>
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import {
  addCategory,
  updateCategory
} from '@/features/printstore/PrintStoreApi'
import { EventBus, Events } from '@/eventbus/EventBus'
import { uuidv4 } from '@/api/uuid'
import { required } from '@vuelidate/validators'
import { logger } from '@/logger'

export default {
  props: {
    category: {
      type: Object,
      default: () => {
        return { name: undefined, colour: '', active: true, listOnTop: false }
      }
    }
  },
  data() {
    return {
      isNew: !this.category.id,
      displayCategory: {},
      saving: false
    }
  },
  mounted() {
    this.$refs.name.focus()
    this.displayCategory = { ...this.category }
  },
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    save() {
      this.saving = true
      if (this.isNew) {
        this.displayCategory.id = uuidv4()
        addCategory(this.displayCategory)
          .then(() => {
            EventBus.emit(Events.CATEGORY_UPDATED)
            this.$emit('close')
          })
          .catch((error) => logger.error(error))
      } else {
        updateCategory(this.displayCategory)
          .then(() => {
            EventBus.emit(Events.CATEGORY_UPDATED)
            this.$emit('close')
          })
          .catch((error) => logger.error(error))
      }
    },
    catExists() {
      if (
        this.printStoreStore.categories.some(
          (e) =>
            e.name === this.displayCategory.name &&
            e.id !== this.displayCategory.id
        )
      ) {
        return true
      } else {
        return false
      }
    },
    setListOnTop() {
      this.displayCategory.listOnTop = !this.displayCategory.listOnTop
      this.$v.displayCategory.$touch()
    },
    setHidden() {
      this.displayCategory.active = !this.displayCategory.active
      this.$v.displayCategory.$touch()
    },
    setNewBadge() {
      this.displayCategory.newBadge = !this.displayCategory.newBadge
      this.$v.displayCategory.$touch()
    },
    onNameInput() {
      this.$v.displayCategory.$touch()
      this.catExists()
    }
  },
  validations: {
    displayCategory: {
      name: {
        required
      }
    }
  }
}
</script>
<style lang="scss" scoped>
label {
  width: 110px;
}

.field-wrapper {
  //margin-bottom: 50px;
}

.select-wrapper {
  margin: 5px 0 15px;
}

.error {
  color: var(--error-color);
  height: 40px;
}

.cancel {
  margin-right: 5px;
}
</style>
